module.exports = __webpack_public_path__ + "img/defaultProductImg_HR.283cccdc.png";